export const css = {
	root: '_1H_zIftz',
	' _key': 'certwise-theme/certwise/lcc-app/content'
};

export default css;
